import {ErrorConstants,clearCookiesAndNavigateforGlobalNetwork} from '../../../src/CommonImports';



export const ErrorFunction = (functionString,error) => {
    console.error('ErrorCode :'+error.code);
    console.error(functionString, error);
    console.log(error)


    
    if(error.code===ErrorConstants.NETWORK_ERROR_CODE){
    //This error occur when backend server is down OR Frontend server is not able to connect to backend server. 
      console.error(ErrorConstants.NETWORK_ERROR_CODE, error.message);
      clearCookiesAndNavigateforGlobalNetwork(error.code,ErrorConstants.NETWORK_ERROR_CODE)
    
      }else{
        if(error.code===ErrorConstants.ERR_BAD_REQUEST_CODE && error.response.data.statusCodeValue===400){  
        //This error occur when no data available. Error code 400. Bad request 
        console.error(ErrorConstants.ERR_BAD_REQUEST_MSG);
        clearCookiesAndNavigateforGlobalNetwork(ErrorConstants.ERR_BAD_REQUEST_CODE,error.response.data.statusCodeValue)

        }
        else if(error.code===ErrorConstants.ERR_BAD_REQUEST_CODE && error.response.data.statusCodeValue===401){
        //This error occur when credential is false
                console.error(ErrorConstants.INVALID_CREDENTIAL);
                //alert(error.response.data.body.errorMsg);
                return error.response.data.body.errorMsg;
                
        }
        else if(error.code===ErrorConstants.ERR_BAD_REQUEST_CODE && error.status===423){
            //alert(error.response.data);
            //alert('rrr'+error.code);
            return error.response.data;
        }
        else if(error.code===ErrorConstants.ERR_BAD_RESPONSE_CODE && error.status===500){
            //This error occur when System error happened due to data issue or code issue. Error code 500 Bad response
                console.error(ErrorConstants.ERR_BAD_RESPONSE_MSG);
                clearCookiesAndNavigateforGlobalNetwork(ErrorConstants.ERR_BAD_RESPONSE_CODE,error.response.data.statusCodeValue)

        }
         else if( error.status===503){
                console.error(ErrorConstants.ERR_SERVICE_UNABLE);
                clearCookiesAndNavigateforGlobalNetwork(error.status,error.status)

        }
        // else { 
        //      //This is generic error.
        //      console.error('Generic error.'+error.code);
        //      clearCookiesAndNavigateforGlobalNetwork("Generic error",error.code)
        //      ///alert('Generic error.'+error.response.data);
        // }
        
    }
};